import { TodoFolder } from 'owa-todo-types';

export function isFlaggedEmailFolder(folder: TodoFolder): boolean {
    return folder.FolderType === 'FlaggedEmails';
}
